import React from "react"

import Page from "../components/Page"

const Page404 = () => <Page title="Nie znaleziono">NOT FOUND</Page>

export default Page404
